export default "__VITE_ASSET__DNSJHXTx__"